export type ProviderRun = {
  provider?: string;
  status: string;
};

export function runProviderLabel(job: ProviderRun, queuedLabel: string) {
  if (job.provider) return job.provider;
  return job.status === "queued" ? queuedLabel : "selecting provider";
}
